export default __webpack_public_path__ + "static/media/terminal-request-img.4e44c4cb.svg";